"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {Typography} from "@/shared/ui/data-display/typography";
import {assetPath} from "@/shared/utils/asset-path";

import "./styles/benefits-sidebar.scss";

interface BenefitsSidebarProps {
    className?: string;
}

export function BenefitsSidebar({className = ""}: BenefitsSidebarProps): JSX.Element {
    return (
        <section className={`benefits-sidebar ${className}`}>
            <div className="benefits-sidebar__list">
                <div className="benefits-sidebar__item">
                    <SmartImage src={assetPath("/images/icons/calendar-cancel.svg")} alt="Worry-free cancellation" width={24} height={24} />
                    <div className="benefits-sidebar__item-text">
                        <Typography as="h3" size={{desktop: 14, mobile: 14}} weight={600} color="title">
                            Worry-free cancellation
                        </Typography>
                        <Typography as="p" size={{desktop: 12, mobile: 12}} weight={400} lineHeight={150} color="paragraph2">
                            Get a full refund if you cancel within 24 hours of booking*
                        </Typography>
                    </div>
                </div>

                <div className="benefits-sidebar__item">
                    <SmartImage src={assetPath("/images/icons/support.svg")} alt="24/7 guest support" width={24} height={24} />
                    <div className="benefits-sidebar__item-text">
                        <Typography as="h3" size={{desktop: 14, mobile: 14}} weight={600} color="title">
                            24/7 guest support
                        </Typography>
                        <Typography as="p" size={{desktop: 12, mobile: 12}} weight={400} lineHeight={150} color="paragraph2">
                            Count on care — just a call, text, or email away
                        </Typography>
                    </div>
                </div>

                <div className="benefits-sidebar__item benefits-sidebar__item--no-border">
                    <SmartImage src={assetPath("/images/icons/dollar.svg")} alt="Best pricing" width={24} height={24} />
                    <div className="benefits-sidebar__item-text">
                        <Typography as="h3" size={{desktop: 14, mobile: 14}} weight={600} color="title">
                            Best pricing
                        </Typography>
                        <Typography as="p" size={{desktop: 12, mobile: 12}} weight={400} lineHeight={150} color="paragraph2">
                            Book directly for the lowest rates
                        </Typography>
                    </div>
                </div>
            </div>

            <Typography as="p" size={{desktop: 12, mobile: 12}} weight={400} color="primary" className="benefits-sidebar__note">
                * Exceptions Apply
            </Typography>
        </section>
    );
}
